// user account page
export const ACCOUNT_LAYOUT_ROUTE = "/account";
